import type { SecretPropertyAPIType } from 'security-app/hooks/api/assetsAPI.types';

export const notEmptyValidation = (value: string): boolean => value && value.replace(/\s/g, '').length > 0;

export const hushedValueValidation = (value: SecretPropertyAPIType | string): boolean => {
  if (typeof value === 'string') return notEmptyValidation(value);
  if (value.is_set || value.keep_value) return true;

  return notEmptyValidation(value.set_value);
};
